import {Button} from '@wandb/weave/components/Button';
import React, {type FC, useContext, useState} from 'react';

import {CreateTeamDrawer} from '../../../pages/HomePage/HomePageSidebar/CreateTeamDrawer';
import {trackNavRightFeatureOpened} from '../../../services/analytics/productEvents';
import {
  useIsAdminModeActiveAndIsNotLocalEnv,
  viewingAs,
} from '../../../util/admin';
import {useNavContext} from '../../NavContextProvider';
import {AccountSelectorContext} from './AccountSelectorContextProvider';

const InviteTeammatesButton: FC = () => {
  const {isCreatingTeam} = useNavContext();
  const [isCreatingTeamInvite, setIsCreatingTeamInvite] = useState(false);
  const {selectedAccount} = useContext(AccountSelectorContext);
  const isAdminMode =
    useIsAdminModeActiveAndIsNotLocalEnv() || viewingAs() !== '';

  const toggleTeamInviteDrawer = () => {
    if (!isCreatingTeamInvite) {
      trackNavRightFeatureOpened({
        feature: 'invite_teammates',
        selected_account: selectedAccount,
        is_admin_mode: isAdminMode,
      });
    }
    setIsCreatingTeamInvite(!isCreatingTeamInvite);
  };

  return (
    <>
      <Button
        icon="users-team"
        className="hidden sm:flex"
        twWrapperStyles={{
          marginRight: '7px',
          marginLeft: '7px',
        }}
        size="large"
        disabled={isCreatingTeam}
        onClick={toggleTeamInviteDrawer}>
        Invite teammates
      </Button>
      <CreateTeamDrawer
        open={isCreatingTeamInvite}
        toggleTeamDrawer={toggleTeamInviteDrawer}
        analyticsLocation="top nav bar"
      />
    </>
  );
};

InviteTeammatesButton.displayName = 'InviteTeammatesButton';

export default InviteTeammatesButton;
